module.exports = __webpack_public_path__ + "img/verification.cd2838b3.png";